import { baseNormalizeData } from './baseNormalizeData';

export const normalizeContentContributorsData = (data: any) => {
	const { contentContributors } = baseNormalizeData(data);

	return {
		nodes: contentContributors.nodes ?? [],
	};
};
